import { useMutation } from "@tanstack/react-query";
import { startTrainingForUsers } from "api/services/lesson-service";
import { useAuthContext } from "hooks/useAuthContext";

export const useStartTrainingForUsers = () => {
    const { userState } = useAuthContext();

    const mutation = useMutation({
        mutationFn: async ({ lessonId, userIds }: { lessonId: string; userIds: string[] }) => {
            const workspaceId = userState.user.selectedWorkspace.workspaceId;

            if (!workspaceId) {
                return null;
            }

            return startTrainingForUsers({ lessonId, userIds, workspaceId });
        }
    });

    const startTrainingForUsersMethod = async (lessonId: string, userIds: string[]) => {
        return mutation.mutateAsync({ lessonId, userIds });
    };

    return { startTrainingForUsers: startTrainingForUsersMethod, startTrainingForUsersPending: mutation.isPending };
}